import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * Impression papier. La feuille est rendue dans un conteneur `#papier-racine` posé directement dans <body> : à l'écran il est
 * masqué, à l'impression tout le reste de l'application est masqué et seul lui s'affiche (A4 paysage, marges 12 mm). La même
 * feuille sert à l'aperçu avant impression (composant <Feuille> dans une fenêtre), pour voir exactement ce qui sortira.
 */
const STYLE_PAPIER = `
@page { size: A4 landscape; margin: 12mm; }
@media screen { #papier-racine { display: none; } }
@media print {
  body > *:not(#papier-racine) { display: none !important; }
  #papier-racine { display: block !important; color: #000; background: #fff; }
  #papier-racine * { color: #000 !important; background: transparent !important; box-shadow: none !important; }
  #papier-racine table { border-collapse: collapse; width: 100%; }
  #papier-racine th, #papier-racine td { border-bottom: 1px solid #999; padding: 3px 6px; text-align: left; vertical-align: top; font-size: 10.5pt; }
  #papier-racine thead { display: table-header-group; }
  #papier-racine tr { break-inside: avoid; }
}`;

/** Feuille à l'écran (aperçu) et à l'impression : mêmes éléments. */
export const Feuille: React.FC<{ children: React.ReactNode }> = ({ children }) => <div className="feuille-papier text-[12px] text-content">{children}</div>;

export const usePapier = () => {
    const [contenu, setContenu] = useState<React.ReactNode | null>(null);
    useEffect(() => {
        if (!contenu) return undefined;
        const fin = () => setContenu(null);
        window.addEventListener('afterprint', fin);
        const t = window.setTimeout(() => window.print(), 150);
        return () => { window.removeEventListener('afterprint', fin); window.clearTimeout(t); };
    }, [contenu]);
    const portail = contenu ? createPortal(<div id="papier-racine"><style>{STYLE_PAPIER}</style>{contenu}</div>, document.body) : null;
    return { imprimer: (c: React.ReactNode) => setContenu(c), portail };
};

/** Règles d'impression exposées pour les tests de rendu (voir INTEGRATION-MAQUETTES.md). */
export const STYLE_IMPRESSION = STYLE_PAPIER;
